import { API_BASE_URL } from "../config/config";

export const fetchOrdersByUserId = async (userId) => {
  try {
    const tokenData = JSON.parse(localStorage.getItem("tokenData")) || {};
    const accessToken = tokenData.accessToken;

    if (!accessToken) {
      console.error('No access token found in localStorage');
      return [];
    }

    console.log('Fetching orders for user:', userId);
    const response = await fetch(`${API_BASE_URL}user/order/all/?id=${userId}`, {
      method: 'GET',
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${accessToken}`
      },
    });
    
    console.log('Response status:', response.status);
    const result = await response.json();
    console.log('API Response:', result);

    if (!response.ok) {
      throw new Error(result.message || 'Failed to fetch orders');
    }

    return result.data || [];
  } catch (error) {
    console.error('Error in fetchOrdersByUserId:', error);
    return [];
  }
};

export const fetchOrderByInvoiceNumber = async (invoiceNumber) => {
  try {
    const tokenData = JSON.parse(localStorage.getItem("tokenData")) || {};
    const accessToken = tokenData.accessToken;

    if (!accessToken) {
      console.error('No access token found in localStorage');
      return null;
    }

    const response = await fetch(`${API_BASE_URL}user/order/single/?id=${invoiceNumber}`, {
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${accessToken}`
      }
    });

    if (!response.ok) {
      throw new Error('Failed to fetch order');
    }
    const result = await response.json();
    return result.data || null;
  } catch (error) {
    console.error('Error in fetchOrderByInvoiceNumber:', error);
    return null;
  }
};
